import { useSquadSystemFitContext } from "../contexts/SquadSystemFitContext";
import { IexpectedLeaguePositions } from "../types/IClubDetail";

export  const getOrdinalSuffix = (num: number) => {
    if (!num) return ""; // Handle undefined/null cases
    const suffixes = ["th", "st", "nd", "rd"];
    const v = num % 100;
    return num + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
};

export const getLeaguePositionDetails = (clubData: {
    currentLeaguePosition: number;
    currentExpectedLeaguePosition: number;
    // expectedLeaguePositions?: IexpectedLeaguePositions[];
  }
  // ,selectedSeasonId?: number
) => {
    // const {selectedSeasonId} = useSquadSystemFitContext();
    const leaguePosition = clubData?.currentLeaguePosition;
    const expectedPosition = clubData?.currentExpectedLeaguePosition;
  
    const formattedPosition = leaguePosition ? getOrdinalSuffix(leaguePosition) : '';
    //const difference = expectedPosition - leaguePosition;
    const difference = leaguePosition - expectedPosition;

    // const expectedEntry = clubData?.expectedLeaguePositions?.find(
    //   (e) => e.seasonId === selectedSeasonId
    // );
  
    // const expectedPositionbySeason = expectedEntry?.expectedPosition! - leaguePosition;
  
    let formattedDifference = '';
    let differenceColor = '';
    let tooltipText = '';

    let formattedDifferencebySeason = ''
    let differenceColorbySeason = ''
    let tooltipTextbySeason = ''
  
    if (difference > 0){
      formattedDifference = `+${difference}`;
      differenceColor = '#00D1A8';
      //tooltipText = `${difference} league positions higher than expected at this stage in the season`;
      tooltipText = `Expected position is ${difference} higher than current league position`;
    } else if (difference) {
      formattedDifference = `${difference}`;
      differenceColor = '#FF3864';
      tooltipText = `Expected position is ${Math.abs(difference)} lower than current league position`;
    } else {
      formattedDifference = '+0';
      differenceColor = 'gray';
      tooltipText = `No difference from expected league position at this stage in the season`;
    }


    // if (expectedPositionbySeason > 0){
    //   formattedDifferencebySeason = `+${expectedPositionbySeason}`;
    //   differenceColorbySeason = '#00D1A8';
    //   tooltipTextbySeason = `${expectedPositionbySeason} league positions higher than expected at this stage in the season`;
    // } else if (expectedPositionbySeason) {
    //   formattedDifferencebySeason = `${expectedPositionbySeason}`;
    //   differenceColorbySeason = '#FF3864';
    //   tooltipTextbySeason = `${Math.abs(expectedPositionbySeason)} league positions lower than expected at this stage in the season`;
    // } else {
    //   formattedDifferencebySeason = '+0';
    //   differenceColorbySeason = 'gray';
    //   tooltipTextbySeason = `No difference from expected league position at this stage in the season`;
    // }

  
    return {
      formattedPosition,
      formattedDifference,
      differenceColor,
      tooltipText,
      expectedPosition
    //   expectedPositionbySeason,
    //  formattedDifferencebySeason,
    //   differenceColorbySeason,
    //   tooltipTextbySeason
    };
  };
  
  